import * as PlotHelpers from './plotHelpers';
import {SmoothingType} from './math';
export interface Settings {
  smoothingWeight: number;
  smoothingType: SmoothingType;
  xAxis: PlotHelpers.XAxisValues | string;
  xAxisChanged?: boolean;
  ignoreOutliers: boolean;
  xAxisMin?: number;
  xAxisMax?: number;
}

export const EMPTY_SETTINGS: Settings = {
  smoothingWeight: 0,
  smoothingType: 'exponential',
  xAxis: PlotHelpers.XAxisValues.Step,
  ignoreOutliers: false,
  xAxisChanged: false,
};
